export class KeywordTranslation
{
    id: number;
    locale: string;
    name: string;
}
